import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { VDRFileSourceType } from '../models/vdr-file-source-type.enum';

export interface VDRFileDownloadInfo {
    fileId: number;
    fileSourceType: VDRFileSourceType;
}

export interface DownloadVDRFilesRequest {
    engagementId: number;
    files: VDRFileDownloadInfo[];
}

export const DownloadVDRFiles = createAsyncThunk(
    'dataRoom/downloadFiles',
    async (
        { engagementId, files }: DownloadVDRFilesRequest,
        { getState }: any
    ) => {
        const axios = getState().core.axios;

        try {
            const response = await axios.post(
                `api/VirtualDataRoomDocument/${engagementId}/files/download`,
                {
                    files,
                },
                {
                    responseType: 'blob',
                }
            );

            if (response.status !== 200) {
                createNotification(
                    'Could not download files at the moment.',
                    'error'
                );
                throw new Error('Failed to download files');
            }

            return response.data;
        } catch (error) {
            createNotification(
                'An error occurred while downloading files.',
                'error'
            );
            throw error;
        }
    }
);

